import { render, staticRenderFns } from "./BaseErrorState.vue?vue&type=template&id=2d1daaf4&scoped=true&"
import script from "./BaseErrorState.vue?vue&type=script&lang=js&"
export * from "./BaseErrorState.vue?vue&type=script&lang=js&"
import style0 from "./BaseErrorState.vue?vue&type=style&index=0&id=2d1daaf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1daaf4",
  null
  
)

export default component.exports